<template>
  <section class="game section" id="games">
    <div class="container">
      <div class="row">
        <div class="col">
          <h1>
            <span class="firstTitle">{{ $t('our') }}</span>
            <span class="secondTitle">{{ $t('games') }}</span>
          </h1>
        </div>
      </div>

      <!-- Snowy -->
      <div class="row">
        <div class="col-md-6">
          <h1 class="gameName">Snowy</h1>
          <p class="genre">{{ $t('genre_endless_runner') }}</p>
          <p
            class="description"
          >{{ $t('snowy_description') }}</p>
          <div class="col game_button">
            <a
              href="https://apps.apple.com/us/app/snowy/id1546501255"
              class="button-store"
            >
              <!--<i class="fa fa-android fa-2x"></i>-->
              <img src="../assets/apple.png" alt="apple" id="apple" class="apple">
              <p>
                {{ $t('available_on') }}
                <br>
                <span class="strong">App Store</span>
              </p>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.skear.snowy"
              class="button-store"
            >
              <!--<i class="fa fa-android fa-2x"></i>-->
              <img src="../assets/android.png" alt="android" id="android" class="android">
              <p>
                {{ $t('available_on') }}
                <br>
                <span class="strong">Google Play</span>
              </p>
            </a>
            <a
              href="https://skear.fr/snowy/"
              class="button-store"
            >
              <!--<i class="fa fa-android fa-2x"></i>-->
              <img src="../assets/internet.png" alt="internet" id="internet" class="internet">
              <p>
                {{ $t('see_more_on') }}
                <br>
                <span class="strong">{{ $t('website') }}</span>
              </p>
            </a>
          </div>
        </div>
        <div class="col-md-6 encard_game">
          <EncardGameSnowy/>
        </div>
      </div>

      <!-- Robbery Bear -->
      <div class="row mt">
        <div class="col-lg-6">
          <h1 class="gameName">Robbery Bear</h1>
          <p class="genre">{{ $t('genre_arcade') }}</p>
          <p
            class="description"
          >{{ $t('robbery_bear_description') }}</p>
          <div class="col game_button">
            <a
              href="https://apps.apple.com/us/app/robbery-bear/id1559288545"
              class="button-store"
            >
              <!--<i class="fa fa-android fa-2x"></i>-->
              <img src="../assets/apple.png" alt="apple" id="apple" class="apple">
              <p>
                {{ $t('available_on') }}
                <br>
                <span class="strong">App Store</span>
              </p>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.Skear.ThiefApprentice"
              class="button-store"
            >
              <!--<i class="fa fa-android fa-2x"></i>-->
              <img src="../assets/android.png" alt="android" id="android" class="android">
              <p>
                {{ $t('available_on') }}
                <br>
                <span class="strong">Google Play</span>
              </p>
            </a>
          </div>
        </div>
        <div class="col-lg-6 encard_game_portrait">
          <EncardGameRobberyBear/>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import EncardGameRobberyBear from './EncardGameRobberyBear.vue';
import EncardGameSnowy from "./EncardGameSnowy.vue";

export default {
  name: "Game",
  components: {
    EncardGameSnowy,
    EncardGameRobberyBear
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mt{
  margin-top: 2em;
}
.game_button{
  text-align: center;
}
.gameName {
  font-size: 24px;
}
.genre {
  color: rgb(153, 153, 153);
  font-size: 14px;
}
.description {
  font-size: 15px;
}
.encard_game{
  @media (max-width: 768px) {
    margin-top: 20px;
  }
}
.encard_game_portrait{
  @media (max-width: 992px) {
    margin-top: 20px;
  }
}
.button-store {
  display: inline-block;
  width: 193px;
  height: auto;
  padding: 5px 22px;
  border-radius: 5px;
  margin: 10px;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  border: none;
  cursor: pointer;
  color: black;
  text-decoration: none;
  background: white;
  transition: 0.3s;
  &:hover {
    background: #62bedb;
  }
  p {
    float: right;
    padding: 0 0 0 10px;
    font-family: Open Sans, sans-serif;
    font-size: 0.9375rem;
    margin: 0;
  }
  .strong {
    font-weight: bold;
  }
  img {
    width: 2.7em;
    &.internet{
      width: 2em;
      margin-top: 5px;
    }
  }
}
</style>
